/* Shared wishlist store, loaded sitewide (layout/theme.liquid) so the
   header badge, the tarot deck, and the wishlist page all read/write the
   same list. Pure localStorage for now — every call is try/catch-wrapped
   so a blocked/unavailable storage (private mode, browser setting) never
   breaks the page; it just behaves as an always-empty wishlist. Built so
   swapping the storage backend for a customer-account one later only
   means replacing the body of _read/_write/_notify. */
(function () {
  if (window.gwWishlist) return;

  var STORAGE_KEY = 'gw_wishlist_handles';
  var SHARE_NAME_KEY = 'gw_wishlist_share_name';
  var TIP_SEEN_KEY = 'gw_wishlist_tip_seen';
  var listeners = [];

  /* ── Christmas mode (B1) ───────────────────────────────────────────
     Dates come from theme settings (config/settings_schema.json →
     "Christmas list mode"), rendered into the page as JSON by
     layout/theme.liquid so this one shared module is the single source
     of truth for the wording swap everywhere the wishlist is named —
     drawer, toasts, tips, the tarot deck, product pages, sharing.
     "Today" is read in Europe/London specifically (not the visitor's
     own timezone) since the brief calls for UK dates. ?xmas=1/?xmas=0
     force it on/off for testing/screenshots — locked to the SAME
     fail-closed gate as the ?goblin=1 hook (v7): theme.liquid only ever
     renders "allowForceTest": true on unpublished/preview themes, never
     on the published live theme, so a customer can't force seasonal
     wording on live via a URL param. */
  var christmasConfig = (function () {
    try {
      var el = document.getElementById('gw-christmas-config');
      var parsed = el ? JSON.parse(el.textContent) : null;
      return {
        start: (parsed && parsed.start) || '11-01',
        end: (parsed && parsed.end) || '12-25',
        allowForceTest: !!(parsed && parsed.allowForceTest)
      };
    } catch (e) {
      return { start: '11-01', end: '12-25', allowForceTest: false };
    }
  })();

  var FORCE_XMAS = (function () {
    if (!christmasConfig.allowForceTest) return null;
    try {
      var v = new URLSearchParams(window.location.search).get('xmas');
      if (v === '1') return true;
      if (v === '0') return false;
    } catch (e) {}
    return null;
  })();

  function londonMonthDay() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      var mm = '01', dd = '01';
      parts.forEach(function (p) {
        if (p.type === 'month') mm = p.value;
        if (p.type === 'day') dd = p.value;
      });
      return mm + '-' + dd;
    } catch (e) {
      var d = new Date();
      var m2 = String(d.getMonth() + 1);
      var d2 = String(d.getDate());
      if (m2.length < 2) m2 = '0' + m2;
      if (d2.length < 2) d2 = '0' + d2;
      return m2 + '-' + d2;
    }
  }

  function isChristmasMode() {
    if (FORCE_XMAS !== null) return FORCE_XMAS;
    var today = londonMonthDay();
    var start = christmasConfig.start, end = christmasConfig.end;
    if (start <= end) return today >= start && today <= end;
    return today >= start || today <= end; // wraps over New Year's
  }

  function labels() {
    var xmas = isChristmasMode();
    return {
      xmas: xmas,
      listNoun: xmas ? 'Christmas list' : 'wishlist',
      drawerTitle: xmas ? 'Your Christmas list' : 'Your wishlist',
      emptyText: xmas ? "Your Christmas list is empty. Tap the heart on anything you’d like to save it here." : "Your wishlist is empty. Tap the heart on anything you love to save it here.",
      toastSaved: xmas ? 'Saved to your Christmas list' : 'Saved to your wishlist',
      toastRemoved: xmas ? 'Removed from your Christmas list' : 'Removed from your wishlist',
      subheadingVerb: xmas ? 'save to your Christmas list' : 'save to your wishlist',
      addButton: xmas ? 'Add to Christmas list' : 'Add to wishlist',
      addedButton: xmas ? 'In your Christmas list' : 'In your wishlist',
      shareButton: xmas ? 'Send to Santa' : 'Share your wishlist',
      shareTagline: xmas ? 'Leave hints for Santa. Send your list to whoever’s doing the shopping.' : 'Perfect for birthdays, or just a not-so-subtle hint.',
      shareMessage: xmas ? 'Here’s my Goblin Wood Christmas list:' : 'Here’s my Goblin Wood wishlist:',
      shareEmailSubject: xmas ? 'My Goblin Wood Christmas list' : 'My Goblin Wood wishlist',
      tipText: xmas ? 'Tap to save to your Christmas list' : 'Tap to save to your wishlist',
      hoverAdd: xmas ? 'Add to Christmas list' : 'Add to wishlist',
      hoverRemove: xmas ? 'Remove from Christmas list' : 'Remove from wishlist',
      heartLabelAdd: xmas ? 'Add to Christmas list' : 'Add to wishlist',
      heartLabelSaved: xmas ? 'In your Christmas list' : 'In your wishlist',
      overlayNamed: function (name) { return xmas ? (name + "'s Christmas list") : (name + "'s wishlist"); },
      overlayAnon: xmas ? 'A Christmas list' : 'A wishlist'
    };
  }

  // v9.1: each saved item is now {handle, variantId} instead of a bare
  // handle string, so a chosen size/colour travels with the item. _read()
  // transparently upgrades old plain-string entries to {handle,
  // variantId:null} on the way in — the FIRST write after that persists
  // the new shape, so there's no separate migration step and nobody's
  // list is ever touched/lost in the process; it just looks like it was
  // always {handle, variantId:null} as soon as it's read once.
  function _read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      var out = [];
      for (var i = 0; i < parsed.length; i++) {
        var entry = parsed[i];
        if (typeof entry === 'string') {
          out.push({ handle: entry, variantId: null });
        } else if (entry && typeof entry === 'object' && typeof entry.handle === 'string') {
          out.push({ handle: entry.handle, variantId: (typeof entry.variantId === 'number' ? entry.variantId : null) });
        }
      }
      return out;
    } catch (e) {
      return [];
    }
  }

  function _findItem(list, handle) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].handle === handle) return list[i];
    }
    return null;
  }

  function _write(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* storage blocked or full — silently no-op, nothing else to do */
    }
    _notify();
  }

  function _notify() {
    var count = _read().length;
    listeners.forEach(function (fn) {
      try { fn(count); } catch (e) {}
    });
    try {
      document.dispatchEvent(new CustomEvent('gw:wishlist:change', { detail: { count: count } }));
    } catch (e) {}
  }

  var api = {
    // Handle-only list — unchanged shape, for every caller that only
    // ever cared about which products are saved (hearts, the picks
    // strip, badge counts), not their variant.
    getAll: function () {
      var list = _read();
      var handles = [];
      for (var i = 0; i < list.length; i++) handles.push(list[i].handle);
      return handles;
    },
    // Full {handle, variantId}[] — for anything that needs to show or
    // act on the chosen size (the drawer, sharing, the shared-list view).
    getAllItems: function () { return _read(); },
    getVariant: function (handle) {
      var item = _findItem(_read(), handle);
      return item ? item.variantId : null;
    },
    has: function (handle) { return !!_findItem(_read(), handle); },
    count: function () { return _read().length; },
    add: function (handle, variantId) {
      if (!handle) return;
      var list = _read();
      var existing = _findItem(list, handle);
      if (existing) {
        // Already saved — update the variant if a different one was
        // passed (product page: change size, save again), but this is
        // never the first-save path, so no toast/re-add here.
        if (variantId != null && existing.variantId !== variantId) {
          existing.variantId = variantId;
          _write(list);
        }
        return;
      }
      list.push({ handle: handle, variantId: (variantId != null ? variantId : null) });
      _write(list);
      showToast();
    },
    setVariant: function (handle, variantId) {
      var list = _read();
      var item = _findItem(list, handle);
      if (!item) return;
      item.variantId = (variantId != null ? variantId : null);
      _write(list);
    },
    remove: function (handle) {
      var list = _read();
      var next = [];
      var removed = false;
      for (var i = 0; i < list.length; i++) {
        if (list[i].handle === handle) { removed = true; continue; }
        next.push(list[i]);
      }
      if (removed) _write(next);
    },
    toggle: function (handle) {
      if (api.has(handle)) {
        api.remove(handle);
        return false;
      }
      api.add(handle);
      return true;
    },
    // v9.2: Clear list + Undo — clear() wipes everything, setAll()
    // restores a prior snapshot (including each item's chosen variant)
    // exactly as Undo needs it.
    clear: function () { _write([]); },
    setAll: function (items) { _write(items || []); },
    onChange: function (fn) {
      if (typeof fn === 'function') listeners.push(fn);
    },
    isChristmasMode: isChristmasMode,
    labels: labels
  };

  window.gwWishlist = api;

  /* Header badge wiring — lives here (not header.liquid's own script) so
     it works identically on every page without each page needing to
     remember to wire it up. */
  function updateBadge(count) {
    var bubble = document.getElementById('gw-wishlist-count-bubble');
    var number = document.getElementById('gw-wishlist-count-number');
    if (!bubble || !number) return;
    if (count > 0) {
      number.textContent = count > 99 ? '99+' : String(count);
      bubble.hidden = false;
    } else {
      bubble.hidden = true;
    }
  }

  api.onChange(updateBadge);

  // ── Shared product-card heart (C2/C3) ───────────────────────────
  // One implementation for every card type sitewide — collections,
  // carousels, search results, franchise pages, new arrivals, the
  // product page button — so saved/not-saved state, styling and
  // behaviour never drift between copies (snippets/gw-wishlist-heart.
  // liquid renders the markup; this wires all of them at once,
  // including any rendered later into the page, e.g. predictive search
  // results or an infinite-scroll grid, via a second initHearts() call
  // on that new content).
  function syncHeart(heart) {
    var handle = heart.getAttribute('data-gw-heart-handle');
    var saved = api.has(handle);
    var l = labels();
    heart.setAttribute('aria-pressed', saved ? 'true' : 'false');
    // aria-label describes the ACTION (what tapping does); the visible
    // slide-out pill shows simpler STATE wording ("In your wishlist" vs
    // "Add to wishlist") — deliberately different strings. No `title`
    // here (removed) — it produced the browser's own native tooltip on
    // hover, which showed up alongside the pill as a second, separate
    // label; aria-label alone still covers screen readers/touch.
    var actionText = saved ? l.hoverRemove : l.hoverAdd;
    heart.setAttribute('aria-label', actionText);
    var labelEl = heart.querySelector('[data-gw-heart-label]');
    if (labelEl) labelEl.textContent = saved ? l.heartLabelSaved : l.heartLabelAdd;
  }

  function syncAllHearts() {
    document.querySelectorAll('[data-gw-heart]').forEach(syncHeart);
  }

  api.onChange(syncAllHearts);

  function initHearts(root) {
    var scope = root || document;
    var hearts = scope.querySelectorAll('[data-gw-heart]');
    hearts.forEach(function (heart) {
      syncHeart(heart);
      if (heart.dataset.gwHeartWired) return;
      heart.dataset.gwHeartWired = '1';
      heart.addEventListener('click', function (e) {
        // Never let this open the card's own product link.
        e.preventDefault();
        e.stopPropagation();
        markTipSeen();
        var handle = heart.getAttribute('data-gw-heart-handle');
        var saved = api.toggle(handle);
        syncAllHearts();
        if (saved) {
          try { api.flyHeartFrom(heart.getBoundingClientRect()); } catch (err) {}
        } else {
          showToast(true);
        }
      });
    });

    if (!tipSeen()) {
      var firstVisible = null;
      for (var i = 0; i < hearts.length; i++) {
        var r = hearts[i].getBoundingClientRect();
        if (r.width > 0 && r.top < window.innerHeight && r.bottom > 0) {
          firstVisible = hearts[i];
          break;
        }
      }
      if (firstVisible) maybeShowTip(firstVisible);
    }
  }

  api.initHearts = initHearts;

  // ── Secondary badge icon chips (v8, touch flow reworked v12) ─────
  // Desktop relies on plain CSS :hover to slide the chip's reveal open
  // — only phones (no real hover) need JS. First tap just reveals the
  // label (no navigation, no lightbox) and auto-tucks after ~3s;
  // tapping the SAME chip again while open performs its actual action
  // — for a plain <a> chip (Web Exclusive/bundle) that's just letting
  // the click through to navigate; for a handmade-type chip
  // (data-gw-handmade-trigger) the OTHER delegated listener in
  // gw-handmade-lightbox.liquid (registered on document in the
  // CAPTURE phase, so it always runs before this one regardless of
  // where in the DOM this chip sits) checks the exact same is-open
  // state and opens the lightbox itself, stopping propagation before
  // it ever reaches here — so the "wasOpen" branch below is only ever
  // live for the non-handmade chip types. One open chip at a time.
  // Tapping a chip never opens the product (stopPropagation), same as
  // the heart.
  function initBadgeChips(root) {
    var scope = root || document;
    scope.querySelectorAll('.gw-badge-chip').forEach(function (chip) {
      if (chip.dataset.gwChipWired) return;
      chip.dataset.gwChipWired = '1';
      chip.addEventListener('click', function (e) {
        e.stopPropagation();
        var isTouch = window.matchMedia && window.matchMedia('(hover: none)').matches;
        if (!isTouch) return; // desktop: plain CSS :hover reveals it; a real click still performs the chip's action
        var wasOpen = chip.classList.contains('is-open');
        if (wasOpen) {
          window.clearTimeout(chip._gwTuckTimer);
          return;
        }
        e.preventDefault();
        document.querySelectorAll('.gw-badge-chip.is-open').forEach(function (c) {
          c.classList.remove('is-open');
          window.clearTimeout(c._gwTuckTimer);
        });
        chip.classList.add('is-open');
        chip._gwTuckTimer = window.setTimeout(function () {
          chip.classList.remove('is-open');
        }, 3000);
      });
    });

    if (!window.__gwChipOutsideWired) {
      window.__gwChipOutsideWired = true;
      document.addEventListener('click', function (e) {
        if (e.target.closest('.gw-badge-chip')) return;
        document.querySelectorAll('.gw-badge-chip.is-open').forEach(function (c) {
          c.classList.remove('is-open');
          window.clearTimeout(c._gwTuckTimer);
        });
      });
    }
  }
  api.initBadgeChips = initBadgeChips;

  // ── Product page "Add to wishlist" button (C4) ──────────────────
  function syncWishlistBtn(btn) {
    var handle = btn.getAttribute('data-gw-wishlist-handle');
    var saved = api.has(handle);
    var l = labels();
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    btn.setAttribute('data-saved', saved ? '1' : '0');
    var labelEl = btn.querySelector('[data-gw-wishlist-btn-label]');
    if (labelEl) labelEl.textContent = saved ? l.addedButton : l.addButton;
    // Desktop-only hover swap (see CSS) — while saved, hovering shows
    // "Remove from wishlist" instead of "In your wishlist", so the
    // button's own click-to-remove behavior is discoverable.
    var hoverLabelEl = btn.querySelector('[data-gw-wishlist-btn-label-hover]');
    if (hoverLabelEl) hoverLabelEl.textContent = l.hoverRemove;
  }

  function syncAllWishlistBtns() {
    document.querySelectorAll('[data-gw-wishlist-btn]').forEach(syncWishlistBtn);
  }

  api.onChange(syncAllWishlistBtns);

  // v9.1: reads the product form's own [name="id"] hidden input for the
  // currently-selected variant — the same input Dawn's native variant
  // picker keeps live and buy-buttons.liquid's own Add to bag submits.
  function selectedVariantFor(btn) {
    var formId = btn.getAttribute('data-gw-wishlist-form-id');
    if (!formId) return null;
    var form = document.getElementById(formId);
    var input = form ? form.querySelector('[name="id"]') : null;
    if (!input || !input.value) return null;
    var id = parseInt(input.value, 10);
    return isNaN(id) ? null : id;
  }

  function initWishlistButtons(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-gw-wishlist-btn]').forEach(function (btn) {
      syncWishlistBtn(btn);
      if (btn.dataset.gwWishlistBtnWired) return;
      btn.dataset.gwWishlistBtnWired = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var handle = btn.getAttribute('data-gw-wishlist-handle');
        var variantId = selectedVariantFor(btn);
        if (api.has(handle)) {
          // Already saved — click removes it (same toggle behaviour as
          // the card hearts), back to the outline "Add to wishlist"
          // state. Changing size/colour no longer updates the saved
          // variant via this button; removing stays available from the
          // drawer's own ✕ button too.
          api.remove(handle);
          showToast(true);
        } else {
          api.add(handle, variantId);
          try { api.flyHeartFrom(btn.getBoundingClientRect()); } catch (err) {}
        }
        syncAllWishlistBtns();
      });
    });
  }

  api.initWishlistButtons = initWishlistButtons;

  function init() {
    updateBadge(api.count());
    refreshWishlistWording();
    initHearts(document);
    initWishlistButtons(document);
    initBadgeChips(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Keep multiple open tabs in sync. */
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) _notify();
  });

  /* ── Wishlist drawer ───────────────────────────────────────────
     Sitewide: snippets/gw-wishlist-drawer.liquid is rendered once by
     layout/theme.liquid, same pattern as the cart drawer, and reuses
     its .gw-drawer shell classes/CSS. */
  var drawerListCache = null; // last-rendered handle list, to avoid refetching if unchanged while open

  function formatMoneyCents(cents) {
    return '£' + (cents / 100).toFixed(2);
  }
  // v10.2: before a variant is picked, show the product's own price (or
  // "From £X" when variants actually differ) instead of leaving the
  // price blank — same fix as gw-shared-list.js, same source fields.
  function formatProductPrice(product) {
    if (product.price_varies) return 'From ' + formatMoneyCents(product.price_min);
    return formatMoneyCents(product.price_min != null ? product.price_min : product.price);
  }
  function cdnResize(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }
  // v10: trims the catalogue's own branding suffixes for display in the
  // drawer — same trim gw-shared-list.js does for the shared-list view.
  function displayTitle(title) {
    return String(title || '').replace(/ - (Goblin Wood|Sumthin Wicked) Exclusive$/, '');
  }

  // Shared with gw-shared-list.js (window.gwWishlist.isPreorderTag) so both
  // JS-rendered item lists use the same tag check. /products/{handle}.js
  // returns tags as a comma-separated string.
  function isPreorderTag(product) {
    var tags = product && product.tags;
    if (!tags) return false;
    var list = Array.isArray(tags) ? tags : String(tags).split(',');
    for (var i = 0; i < list.length; i++) {
      var t = String(list[i]).trim().toLowerCase();
      if (t === 'pre-order' || t === 'preorder') return true;
    }
    return false;
  }
  api.isPreorderTag = isPreorderTag;

  // v9.2: shared inline variant picker (Size, Colour, ...) — built once
  // here and reused by both the wishlist drawer and the shared-list
  // overlay (assets/gw-shared-list.js), so the two never drift apart.
  // Tappable bubbles (one row per real product option, using the
  // product's own option names) replacing v9.1's <select> dropdown —
  // never sends the customer to the product page just to pick a size.
  // Options whose value has NO available variant anywhere are shown but
  // disabled/struck-through ("greyed"); the final exact combination is
  // re-checked for availability separately (findVariant()), since
  // graying out by single-option value alone is an approximation, not
  // an exhaustive per-combination check.
  function buildVariantPicker(product, savedVariantId, onVariantChange) {
    if (!product.options || !product.variants || product.variants.length <= 1) return null;

    var wrap = document.createElement('div');
    wrap.className = 'gw-bubble-picker';
    var state = {}; // option index -> chosen value

    var savedVariant = null;
    if (savedVariantId) {
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].id === savedVariantId) { savedVariant = product.variants[i]; break; }
      }
    }

    function optionValue(variant, idx) {
      return variant['option' + (idx + 1)];
    }

    function findVariant() {
      for (var oi = 0; oi < product.options.length; oi++) {
        if (!state[oi]) return null;
      }
      for (var vi = 0; vi < product.variants.length; vi++) {
        var v = product.variants[vi];
        var matches = true;
        for (var oj = 0; oj < product.options.length; oj++) {
          if (optionValue(v, oj) !== state[oj]) { matches = false; break; }
        }
        if (matches) return v;
      }
      return null;
    }

    product.options.forEach(function (optionRaw, idx) {
      // The /products/{handle}.js AJAX API returns options as
      // {name, position, values} objects, not plain strings (found live
      // — this is what was rendering "[object Object]:" as the label
      // before). Defensive fallback to the raw value for any caller
      // that somehow passes plain strings instead.
      var optionName = (optionRaw && typeof optionRaw === 'object' && optionRaw.name) ? optionRaw.name : optionRaw;
      var row = document.createElement('div');
      row.className = 'gw-bubble-row';
      var labelSpan = document.createElement('span');
      labelSpan.className = 'gw-bubble-row__label';
      labelSpan.textContent = optionName;
      var bubbles = document.createElement('div');
      bubbles.className = 'gw-bubble-row__bubbles';

      var seen = {};
      var savedVal = savedVariant ? optionValue(savedVariant, idx) : null;
      product.variants.forEach(function (v) {
        var val = optionValue(v, idx);
        if (seen[val]) return;
        seen[val] = true;
        var anyAvailable = product.variants.some(function (vv) { return optionValue(vv, idx) === val && vv.available; });
        var bubble = document.createElement('button');
        bubble.type = 'button';
        bubble.className = 'gw-bubble';
        bubble.textContent = val;
        if (!anyAvailable) {
          bubble.classList.add('gw-bubble--soldout');
          bubble.disabled = true;
          bubble.setAttribute('aria-label', val + ' — back soon');
        }
        if (savedVal === val) {
          bubble.classList.add('is-selected');
          state[idx] = val;
        }
        bubble.addEventListener('click', function () {
          var siblings = bubbles.querySelectorAll('.gw-bubble');
          Array.prototype.forEach.call(siblings, function (b) { b.classList.remove('is-selected'); });
          bubble.classList.add('is-selected');
          state[idx] = val;
          var match = findVariant();
          if (onVariantChange) onVariantChange(match);
        });
        bubbles.appendChild(bubble);
      });

      row.appendChild(labelSpan);
      row.appendChild(bubbles);
      wrap.appendChild(row);
    });

    return { el: wrap, getSelectedVariant: findVariant };
  }
  api.buildVariantPicker = buildVariantPicker;

  // v9.2: "Size: L · Colour: Red" summary text for the collapsed state
  // after a variant's been chosen — shared so the drawer and the
  // shared-list view render identical wording.
  function describeChosenVariant(product, variant) {
    if (!product.options || !variant) return '';
    var parts = [];
    for (var oi = 0; oi < product.options.length; oi++) {
      var val = variant['option' + (oi + 1)];
      if (!val) continue;
      var optionRaw = product.options[oi];
      var optionName = (optionRaw && typeof optionRaw === 'object' && optionRaw.name) ? optionRaw.name : optionRaw;
      parts.push(optionName + ': ' + val);
    }
    return parts.join(' · ');
  }
  api.describeChosenVariant = describeChosenVariant;

  /* ── Add-to-bag buttons (v10.4) ─────────────────────────────────────
     Every add button in the drawer and the shared list reads the REAL
     cart (/cart.js, kept current via the gw:cart:change event), so the
     label can never disagree with what's actually in the bag. */
  var cartQty = {};
  var bagBindings = [];
  var BAG_TICK = '<svg class="gw-bag-tick" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><path d="M4 12l5 5L20 6"/></svg>';

  function applyCartQty(cart) {
    cartQty = {};
    ((cart && cart.items) || []).forEach(function (it) {
      cartQty[it.variant_id] = (cartQty[it.variant_id] || 0) + it.quantity;
    });
    paintBagBindings();
  }

  function refreshCartQty() {
    return fetch('/cart.js').then(function (r) { return r.text(); }).then(function (t) {
      try { applyCartQty(JSON.parse(t)); } catch (e) { paintBagBindings(); }
    }).catch(function () { paintBagBindings(); });
  }

  function paintBagBindings() {
    bagBindings = bagBindings.filter(function (b) { return document.body.contains(b.btn); });
    bagBindings.forEach(function (b) { b.paint(); });
  }

  document.addEventListener('gw:cart:change', function (e) {
    applyCartQty(e.detail && e.detail.cart);
  });

  function showBagToast() {
    var toast = document.getElementById('gw-bag-toast');
    if (!toast) return;
    toast.hidden = false;
    void toast.offsetWidth;
    toast.classList.add('is-visible');
    window.clearTimeout(showBagToast._t);
    showBagToast._t = window.setTimeout(function () {
      toast.classList.remove('is-visible');
      window.setTimeout(function () { toast.hidden = true; }, 300);
    }, 3200);
  }
  api.showBagToast = showBagToast;
  api.bindBagButton = bindBagButton;

  function bindBagButton(btn, getVariant) {
    var another = document.createElement('button');
    another.type = 'button';
    another.className = 'gw-bag-another';
    another.textContent = '+ Add another';
    another.hidden = true;
    var err = document.createElement('p');
    err.className = 'gw-bag-error';
    err.textContent = "Couldn't add — try again";
    err.hidden = true;
    btn.insertAdjacentElement('afterend', err);
    btn.insertAdjacentElement('afterend', another);

    var busy = false;
    var failed = false;

    function paint() {
      var v = getVariant();
      btn.classList.remove('is-in-bag');
      if (!v) {
        btn.hidden = true; another.hidden = true; err.hidden = true;
        return;
      }
      btn.hidden = false;
      if (!v.available) {
        btn.disabled = true;
        btn.textContent = 'Sold out';
        another.hidden = true; err.hidden = true;
        return;
      }
      var qty = cartQty[v.id] || 0;
      btn.disabled = busy;
      if (busy) {
        btn.innerHTML = '<span class="gw-bag-spinner" aria-hidden="true"></span>Adding…';
      } else if (qty > 0) {
        btn.classList.add('is-in-bag');
        btn.innerHTML = BAG_TICK + (qty === 1 ? 'In your bag' : qty + ' in your bag');
      } else {
        btn.textContent = 'Add to bag';
      }
      another.hidden = busy || qty === 0;
      err.hidden = !failed;
    }

    function add() {
      var v = getVariant();
      if (!v || !v.available || busy || !window.gwAddToCartWithResult) return;
      busy = true; failed = false; paint();
      window.gwAddToCartWithResult(v.id, 1, undefined, undefined, { noDrawer: true })
        .then(function () {
          busy = false; failed = false;
          showBagToast();
          return refreshCartQty();
        })
        .then(function () { paint(); })
        .catch(function () {
          busy = false; failed = true;
          paint();
        });
    }

    btn.addEventListener('click', add);
    another.addEventListener('click', add);

    var binding = { btn: btn, paint: paint };
    bagBindings.push(binding);
    paint();
    return binding;
  }

  function renderDrawerList() {
    var drawer = document.getElementById('gw-wishlist-drawer');
    var loading = document.getElementById('gw-wishlist-drawer-loading');
    var empty = document.getElementById('gw-wishlist-drawer-empty');
    var list = document.getElementById('gw-wishlist-drawer-list');
    var template = document.getElementById('gw-wishlist-drawer-item-template');
    if (!drawer || !template) return;

    var items = api.getAllItems();
    drawerListCache = items.map(function (it) { return it.handle; });

    loading.hidden = false;
    empty.hidden = true;
    list.hidden = true;
    list.innerHTML = '';

    if (items.length === 0) {
      loading.hidden = true;
      empty.hidden = false;
      return;
    }

    Promise.all(
      items.map(function (item) {
        return fetch('/products/' + item.handle + '.js')
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (product) { return product ? { product: product, variantId: item.variantId } : null; })
          .catch(function () { return null; });
      })
    ).then(function (results) {
      loading.hidden = true;
      var valid = results.filter(Boolean);
      if (valid.length === 0) {
        empty.hidden = false;
        return;
      }
      list.hidden = false;
      valid.forEach(function (r) {
        try { renderDrawerItem(r.product, r.variantId, list, template); } catch (e) {}
      });
      refreshCartQty();
    });
  }

  function renderDrawerItem(product, savedVariantId, list, template) {
    var frag = template.content.cloneNode(true);
    var itemEl = frag.querySelector('.gw-wishlist-drawer__item');
    var link = itemEl.querySelector('[data-item-link]');
    var img = itemEl.querySelector('[data-item-img]');
    var titleLink = itemEl.querySelector('[data-item-title-link]');
    var badgeEl = itemEl.querySelector('[data-item-badge]');
    if (badgeEl) badgeEl.hidden = !isPreorderTag(product);
    var priceEl = itemEl.querySelector('[data-item-price]');
    var optionsEl = itemEl.querySelector('[data-item-options]');
    var addBtn = itemEl.querySelector('[data-item-add]');
    var removeBtn = itemEl.querySelector('[data-item-remove]');

    itemEl.setAttribute('data-item-handle', product.handle);

    var url = '/products/' + product.handle;
    link.href = url;
    titleLink.href = url;
    titleLink.textContent = displayTitle(product.title);

    var image = product.featured_image || (product.images && product.images[0]);
    if (image) {
      img.src = cdnResize(image, 300);
      img.alt = product.title;
    }

    var multiVariant = product.variants && product.variants.length > 1;
    var currentVariant = null;
    if (savedVariantId) {
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].id === savedVariantId) { currentVariant = product.variants[i]; break; }
      }
    }
    if (!currentVariant && !multiVariant) {
      currentVariant = product.variants[0];
    }
    var bag = null;

    // v9.2: "Choose size" button replaces Add to bag for multi-variant
    // items until a variant is actually resolved; tapping it slides open
    // the bubble row rather than sending the customer to the product
    // page. Once chosen, the row collapses to "Size: L · Change" and
    // Add to bag reappears, now scoped to that exact variant.
    var chooseBtn = null, chosenRow = null, bubbleWrap = null, picker = null;

    function refreshAddBtn() {
      // Flagged here (not just inside the picker callback) so the
      // pre-share check (below) can find every item that needs a size
      // just by querying this one attribute, without re-deriving
      // multi-variant/chosen state itself.
      itemEl.setAttribute('data-needs-size', (multiVariant && !currentVariant) ? '1' : '0');
      if (multiVariant) {
        if (chooseBtn) chooseBtn.hidden = !!currentVariant;
        if (bubbleWrap && currentVariant) bubbleWrap.hidden = true;
        if (chosenRow) {
          chosenRow.hidden = !currentVariant;
          if (currentVariant) {
            var textEl = chosenRow.querySelector('[data-chosen-size-text]');
            if (textEl) textEl.textContent = describeChosenVariant(product, currentVariant);
          }
        }
      }
      priceEl.textContent = currentVariant ? formatMoneyCents(currentVariant.price) : formatProductPrice(product);
      if (bag) bag.paint();
    }

    if (multiVariant) {
      picker = buildVariantPicker(product, savedVariantId, function (matchedVariant) {
        currentVariant = matchedVariant;
        // Saves the choice immediately, per the brief — no separate
        // confirm step.
        api.setVariant(product.handle, matchedVariant ? matchedVariant.id : null);
        itemEl.classList.remove('is-missing-size');
        if (matchedVariant && bubbleWrap) bubbleWrap.hidden = true;
        refreshAddBtn();
      });

      chooseBtn = document.createElement('button');
      chooseBtn.type = 'button';
      chooseBtn.className = 'gw-size-choose-btn';
      chooseBtn.textContent = 'Choose size';
      chooseBtn.addEventListener('click', function () {
        bubbleWrap.hidden = !bubbleWrap.hidden;
      });

      bubbleWrap = document.createElement('div');
      bubbleWrap.className = 'gw-size-bubble-wrap';
      bubbleWrap.hidden = true;
      if (picker) bubbleWrap.appendChild(picker.el);

      chosenRow = document.createElement('div');
      chosenRow.className = 'gw-size-chosen-row';
      chosenRow.hidden = true;
      var chosenText = document.createElement('span');
      chosenText.setAttribute('data-chosen-size-text', '');
      var changeLink = document.createElement('button');
      changeLink.type = 'button';
      changeLink.className = 'gw-size-change-link';
      changeLink.textContent = 'Change';
      changeLink.addEventListener('click', function () {
        bubbleWrap.hidden = false;
      });
      chosenRow.appendChild(chosenText);
      chosenRow.appendChild(changeLink);

      optionsEl.appendChild(chooseBtn);
      optionsEl.appendChild(bubbleWrap);
      optionsEl.appendChild(chosenRow);
    }

    bag = bindBagButton(addBtn, function () { return currentVariant; });
    refreshAddBtn();

    removeBtn.addEventListener('click', function () {
      api.remove(product.handle);
      itemEl.remove();
      refreshDrawerHeaderMeta(api.getAll().length);
      if (!list.querySelector('.gw-wishlist-drawer__item')) {
        list.hidden = true;
        document.getElementById('gw-wishlist-drawer-empty').hidden = false;
      }
    });

    list.appendChild(itemEl);
  }

  function getShareName() {
    try {
      var n = localStorage.getItem(SHARE_NAME_KEY);
      return n ? n.trim().slice(0, 30) : '';
    } catch (e) {
      return '';
    }
  }
  function setShareName(name) {
    try { localStorage.setItem(SHARE_NAME_KEY, (name || '').trim().slice(0, 30)); } catch (e) {}
  }

  function refreshWishlistWording() {
    var l = labels();
    var title = document.getElementById('gw-wishlist-drawer-title');
    var hint = document.getElementById('gw-wishlist-drawer-title-hint');
    var name = getShareName();
    // .textContent only — this is the one place a person's own typed
    // input is rendered back, so it's never set via innerHTML.
    if (title) title.textContent = name ? l.overlayNamed(name) : l.drawerTitle;
    if (hint) hint.hidden = !!name;
    var empty = document.getElementById('gw-wishlist-drawer-empty-text');
    if (empty) empty.textContent = l.emptyText;
    var shareBtn = document.getElementById('gw-wishlist-share-btn');
    if (shareBtn) shareBtn.textContent = l.shareButton;
    var tagline = document.getElementById('gw-wishlist-drawer-tagline');
    if (tagline) tagline.textContent = l.shareTagline;
    // Hearts and the product-page button re-sync their own text/state
    // via syncAllHearts()/syncAllWishlistBtns() (hoisted, defined below)
    // whenever labels() changes meaning — not duplicated here, and never
    // with an emoji heart character prefix: these buttons use SVG icons
    // for the outline/filled states, same rule as everywhere else.
    if (typeof syncAllHearts === 'function') syncAllHearts();
    if (typeof syncAllWishlistBtns === 'function') syncAllWishlistBtns();
    // v9: the Santa hat (a small appended element on the icon BUTTON)
    // read as a stray glitchy red blob at this size — replaced with the
    // count bubble itself turning festive (red background, white text)
    // plus a tiny holly sprig SVG inserted into the bubble's own corner,
    // which stays legible at small sizes since it's drawn to match the
    // bubble's own scale rather than overlaid loosely on top of it.
    [document.getElementById('gw-wishlist-count-bubble'), document.getElementById('gw-slim-wishlist-count-bubble')].forEach(function (bubble) {
      if (!bubble) return;
      bubble.classList.toggle('is-christmas', !!l.xmas);
      var holly = bubble.querySelector('.gw-wishlist-holly');
      if (l.xmas && !holly) {
        var span = document.createElement('span');
        span.className = 'gw-wishlist-holly';
        span.setAttribute('aria-hidden', 'true');
        span.innerHTML = '<svg viewBox="0 0 24 24" width="100%" height="100%">' +
          '<path d="M12 13c-3-1-5 1-6 4 3 1 6 0 7-2" fill="#2e7d4f"/>' +
          '<path d="M12 13c3-1 5 1 6 4-3 1-6 0-7-2" fill="#1f6b40"/>' +
          '<circle cx="12" cy="15.5" r="2.1" fill="#c81e2c"/>' +
          '</svg>';
        bubble.appendChild(span);
      } else if (!l.xmas && holly) {
        holly.remove();
      }
    });
  }

  // v10: header row now carries the item count and the Clear list link
  // (moved out of share-top, which only ever showed either of them when
  // the list had >=1 item) — kept in sync from every place that used to
  // just toggle share-top's own [hidden].
  function refreshDrawerHeaderMeta(count) {
    var countEl = document.getElementById('gw-wishlist-drawer-count');
    if (countEl) {
      countEl.textContent = '· ' + count + ' item' + (count === 1 ? '' : 's');
      countEl.hidden = count === 0;
    }
    var clearLink = document.getElementById('gw-wishlist-clear-link');
    if (clearLink) clearLink.hidden = count === 0;
    var shareTop = document.getElementById('gw-wishlist-drawer-share-top');
    if (shareTop) shareTop.hidden = count === 0;
  }

  function openDrawer() {
    var drawer = document.getElementById('gw-wishlist-drawer');
    if (!drawer) return;
    refreshWishlistWording();
    var current = api.getAll();
    var stale = !drawerListCache || drawerListCache.length !== current.length ||
      current.some(function (h) { return drawerListCache.indexOf(h) === -1; });
    if (stale) renderDrawerList();
    refreshDrawerHeaderMeta(current.length);
    // Reset the size-prompt/share-options back to their default state
    // each time the drawer opens, rather than leaving them wherever
    // they were left from a previous open.
    var sizePromptReset = document.getElementById('gw-wishlist-size-prompt');
    var namePromptReset = document.getElementById('gw-wishlist-name-prompt');
    var shareBtnReset = document.getElementById('gw-wishlist-share-btn');
    var shareOptionsReset = document.getElementById('gw-wishlist-drawer-share-options');
    if (sizePromptReset) sizePromptReset.hidden = true;
    if (namePromptReset) namePromptReset.hidden = true;
    if (shareBtnReset) shareBtnReset.hidden = false;
    if (shareOptionsReset) shareOptionsReset.hidden = true;
    // Visibility of the link itself is handled by refreshDrawerHeaderMeta
    // above (hidden when the list is empty); only the confirm panel needs
    // resetting back to collapsed on every open.
    var clearConfirmReset = document.getElementById('gw-wishlist-clear-confirm');
    if (clearConfirmReset) clearConfirmReset.hidden = true;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    refreshCartQty();
  }

  function closeDrawer() {
    var drawer = document.getElementById('gw-wishlist-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  function showToast(removed) {
    var toast = document.getElementById('gw-wishlist-toast');
    if (!toast) return;
    var textEl = document.getElementById('gw-wishlist-toast-text');
    if (textEl) textEl.textContent = (removed ? labels().toastRemoved : labels().toastSaved) + ' ·';
    toast.hidden = false;
    void toast.offsetWidth;
    toast.classList.add('is-visible');
    window.clearTimeout(showToast._t);
    showToast._t = window.setTimeout(function () {
      toast.classList.remove('is-visible');
      window.setTimeout(function () { toast.hidden = true; }, 300);
    }, 3200);
  }

  function initDrawer() {
    var drawer = document.getElementById('gw-wishlist-drawer');
    var heartIcon = document.getElementById('gw-wishlist-icon');
    var closeBtn = document.getElementById('gw-wishlist-drawer-close');
    var toastViewBtn = document.getElementById('gw-wishlist-toast-view');

    if (heartIcon) {
      heartIcon.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    }
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (toastViewBtn) {
      toastViewBtn.addEventListener('click', function () {
        document.getElementById('gw-wishlist-toast').classList.remove('is-visible');
        openDrawer();
      });
    }
    var bagViewBtn = document.getElementById('gw-bag-toast-view');
    if (bagViewBtn) {
      bagViewBtn.addEventListener('click', function () {
        document.getElementById('gw-bag-toast').classList.remove('is-visible');
        closeDrawer();
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          if (window.gwOpenCartDrawer) window.gwOpenCartDrawer(null, cart);
        }).catch(function () {});
      });
    }

    // Editable list name (v8), replacing the old separate "Your name"
    // field in the share section — the drawer title IS the name field
    // now. Name is remembered locally (localStorage, 30 chars) purely
    // as a convenience — it's just echoed into the title and the next
    // share link, never sent anywhere.
    var titleBtn = document.getElementById('gw-wishlist-drawer-title-btn');
    var titleInput = document.getElementById('gw-wishlist-drawer-title-input');
    if (titleBtn && titleInput) {
      var enterEdit = function () {
        titleInput.value = getShareName();
        titleBtn.hidden = true;
        var hint = document.getElementById('gw-wishlist-drawer-title-hint');
        if (hint) hint.hidden = true;
        titleInput.hidden = false;
        titleInput.focus();
        titleInput.select();
      };
      var exitEdit = function (save) {
        if (save) setShareName(titleInput.value);
        titleInput.hidden = true;
        titleBtn.hidden = false;
        refreshWishlistWording();
      };
      titleBtn.addEventListener('click', enterEdit);
      titleInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); exitEdit(true); }
        else if (e.key === 'Escape') { e.preventDefault(); exitEdit(false); }
      });
      titleInput.addEventListener('blur', function () { exitEdit(true); });
    }

    // Share your wishlist / Send to Santa (v9) — moved to the top of
    // the drawer, under the editable name. Touch devices call
    // navigator.share() directly from the main button (native share
    // sheet); desktop instead reveals three explicit options below it
    // (copy link / WhatsApp / email) rather than calling navigator.
    // share() — some desktop browsers/OSes DO implement the Web Share
    // API (e.g. Windows' own share dialog in recent Chrome/Edge), which
    // would otherwise pop up there too even though nothing asked for
    // it; gating on touch is what the brief explicitly calls for.
    // Handles in the URL are capped to the 50 most recently saved.
    // v9.1: handle:variantId in the share URL (plain handle when no
    // variant is chosen) so the person opening the link sees the right
    // size without having to guess.
    // v10: this is now the FALLBACK long link — used only when the app's
    // short-link endpoint can't be reached, so sharing never breaks.
    function buildLongShareUrl() {
      var items = api.getAllItems().slice(-50);
      if (!items.length) return null;
      var url = new URL(window.location.origin + '/');
      var parts = items.map(function (it) {
        return it.variantId ? (it.handle + ':' + it.variantId) : it.handle;
      });
      url.searchParams.set('list', parts.join(','));
      var name = getShareName();
      if (name) url.searchParams.set('name', name);
      return url;
    }

    // v10: asks the app to mint a short /l/<code> link for the current
    // list. Returns a URL on success, or null on ANY failure (network
    // error, non-ok response, malformed JSON) — callers fall back to
    // buildLongShareUrl() so sharing itself never breaks even if the app
    // is briefly unreachable.
    function createShortShareUrl() {
      var items = api.getAllItems().slice(-50);
      if (!items.length) return Promise.resolve(null);
      var body = {
        action: 'create_shared_list',
        items: items.map(function (it) { return { handle: it.handle, variantId: it.variantId || undefined }; }),
        name: getShareName() || undefined,
        isChristmas: !!labels().xmas,
      };
      return fetch('/apps/rewards', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          if (!data || !data.ok || !data.code) return null;
          return new URL(window.location.origin + '/apps/rewards/l/' + data.code);
        })
        .catch(function () { return null; });
    }

    // Resolves to a URL (short if the app call succeeds, long otherwise)
    // — the single source every share surface (native share, copy,
    // WhatsApp, email) pulls from, so they're never out of sync.
    function resolveShareUrl() {
      return createShortShareUrl().then(function (shortUrl) {
        return shortUrl || buildLongShareUrl();
      });
    }

    var shareBtn = document.getElementById('gw-wishlist-share-btn');
    var shareOptions = document.getElementById('gw-wishlist-drawer-share-options');
    var shareStatus = document.getElementById('gw-wishlist-share-status');
    var shareCopyBtn = document.getElementById('gw-wishlist-share-copy');
    var shareWhatsappLink = document.getElementById('gw-wishlist-share-whatsapp');
    var shareEmailLink = document.getElementById('gw-wishlist-share-email');
    var sizePrompt = document.getElementById('gw-wishlist-size-prompt');
    var sizePromptText = document.getElementById('gw-wishlist-size-prompt-text');
    var shareAnywayBtn = document.getElementById('gw-wishlist-share-anyway');

    function setShareStatus(msg) {
      if (!shareStatus) return;
      shareStatus.textContent = msg;
      shareStatus.hidden = false;
      window.clearTimeout(setShareStatus._t);
      setShareStatus._t = window.setTimeout(function () { shareStatus.hidden = true; }, 3000);
    }

    function doShare() {
      // Closing an already-open options panel needs no network round
      // trip — just collapse it back.
      if (shareOptions && !shareOptions.hidden) {
        shareOptions.hidden = true;
        return;
      }
      var l = labels();
      var originalText = shareBtn ? shareBtn.textContent : '';
      if (shareBtn) { shareBtn.disabled = true; shareBtn.textContent = l.xmas ? 'Wrapping your list…' : 'Packing your list…'; }
      resolveShareUrl().then(function (url) {
        if (shareBtn) { shareBtn.disabled = false; shareBtn.textContent = originalText; }
        if (!url) return;
        var message = l.shareMessage + ' ' + url.toString();
        var isTouch = window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches;
        if (isTouch && navigator.share) {
          navigator.share({ title: l.shareEmailSubject, text: message }).catch(function () {});
          return;
        }
        if (!shareOptions) return;
        shareOptions.hidden = false;
        if (shareWhatsappLink) shareWhatsappLink.href = 'https://wa.me/?text=' + encodeURIComponent(message);
        if (shareEmailLink) shareEmailLink.href = 'mailto:?subject=' + encodeURIComponent(l.shareEmailSubject) + '&body=' + encodeURIComponent(message);
        if (shareCopyBtn) shareCopyBtn.dataset.shareMessage = message;
      });
    }

    // v9.1: items that still need a size are flagged live by
    // renderDrawerItem() (data-needs-size="1") — checked fresh on every
    // share attempt, not cached, so it always reflects the current
    // picker state.
    function missingSizeItems() {
      return document.querySelectorAll('#gw-wishlist-drawer-list [data-needs-size="1"]');
    }

    // v10.1: name prompt — shown once sizes are sorted, only when no
    // name is saved yet. Skip shares anonymously (unchanged behavior);
    // Save & share writes the name to the same place the editable title
    // reads from, so it also updates the drawer heading immediately.
    var namePrompt = document.getElementById('gw-wishlist-name-prompt');
    var namePromptInput = document.getElementById('gw-wishlist-name-prompt-input');
    var namePromptSave = document.getElementById('gw-wishlist-name-prompt-save');
    var namePromptSkip = document.getElementById('gw-wishlist-name-prompt-skip');

    function proceedToShare() {
      if (namePrompt && !getShareName()) {
        if (shareBtn) shareBtn.hidden = true;
        if (namePromptInput) namePromptInput.value = '';
        namePrompt.hidden = false;
        if (namePromptInput) namePromptInput.focus();
        return;
      }
      doShare();
    }

    if (namePromptSave) {
      namePromptSave.addEventListener('click', function () {
        if (namePromptInput && namePromptInput.value.trim()) {
          setShareName(namePromptInput.value);
          refreshWishlistWording();
        }
        namePrompt.hidden = true;
        if (shareBtn) shareBtn.hidden = false;
        doShare();
      });
    }
    if (namePromptInput) {
      namePromptInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && namePromptSave) { e.preventDefault(); namePromptSave.click(); }
      });
    }
    if (namePromptSkip) {
      namePromptSkip.addEventListener('click', function () {
        namePrompt.hidden = true;
        if (shareBtn) shareBtn.hidden = false;
        doShare();
      });
    }

    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var missing = missingSizeItems();
        if (missing.length) {
          var l = labels();
          if (sizePromptText) {
            sizePromptText.textContent = missing.length + ' item' + (missing.length === 1 ? '' : 's') +
              ' need' + (missing.length === 1 ? 's' : '') + ' a size — pick ' + (missing.length === 1 ? 'it' : 'them') +
              ' so ' + (l.xmas ? 'Santa gets it right' : 'they get it right');
          }
          if (sizePrompt) sizePrompt.hidden = false;
          shareBtn.hidden = true;
          Array.prototype.forEach.call(missing, function (el) { el.classList.add('is-missing-size'); });
          missing[0].scrollIntoView({ behavior: REDUCED_MOTION() ? 'auto' : 'smooth', block: 'center' });
          return;
        }
        proceedToShare();
      });
    }
    if (shareAnywayBtn) {
      shareAnywayBtn.addEventListener('click', function () {
        if (sizePrompt) sizePrompt.hidden = true;
        proceedToShare();
      });
    }
    if (shareCopyBtn) {
      shareCopyBtn.addEventListener('click', function () {
        // Set by doShare() once the share options panel opens — copies
        // the same friendly sentence ("Here's my Goblin Wood wishlist:
        // <link>") used everywhere else, never a bare URL.
        var message = shareCopyBtn.dataset.shareMessage;
        if (!message) return;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(message).then(function () {
            setShareStatus('Copied');
          }).catch(function () {
            setShareStatus(message);
          });
        } else {
          setShareStatus(message);
        }
      });
    }

    // Clear list / Undo (v9.2). Confirm happens inside the drawer, not
    // via a native confirm() dialog, so it matches the rest of the UI
    // and the Undo toast can restore from an in-memory snapshot.
    var clearLink = document.getElementById('gw-wishlist-clear-link');
    var clearConfirm = document.getElementById('gw-wishlist-clear-confirm');
    var clearConfirmText = document.getElementById('gw-wishlist-clear-confirm-text');
    var clearYesBtn = document.getElementById('gw-wishlist-clear-yes');
    var clearCancelBtn = document.getElementById('gw-wishlist-clear-cancel');
    var clearToast = document.getElementById('gw-wishlist-clear-toast');
    var clearToastText = document.getElementById('gw-wishlist-clear-toast-text');
    var clearUndoBtn = document.getElementById('gw-wishlist-clear-undo');

    if (clearLink && clearConfirm) {
      clearLink.addEventListener('click', function () {
        var l = labels();
        if (clearConfirmText) clearConfirmText.textContent = 'Clear your whole ' + l.listNoun + '?';
        clearConfirm.hidden = false;
        clearLink.hidden = true;
      });
    }
    if (clearCancelBtn) {
      clearCancelBtn.addEventListener('click', function () {
        clearConfirm.hidden = true;
        clearLink.hidden = false;
      });
    }
    if (clearYesBtn) {
      clearYesBtn.addEventListener('click', function () {
        var snapshotItems = api.getAllItems();
        var snapshotName = getShareName();
        api.clear();
        // onChange listeners (badge, hearts, picks strip) fire from
        // _notify(), but the drawer's own list only re-renders when
        // opened — it needs an explicit render here since Clear always
        // happens while the drawer is already open.
        renderDrawerList();
        refreshDrawerHeaderMeta(0);
        clearConfirm.hidden = true;

        if (clearToast) {
          var l = labels();
          if (clearToastText) clearToastText.textContent = l.xmas ? 'Christmas list cleared' : 'List cleared';
          clearToast.hidden = false;
          void clearToast.offsetWidth;
          clearToast.classList.add('is-visible');
          var hideTimer = window.setTimeout(function () {
            clearToast.classList.remove('is-visible');
            window.setTimeout(function () { clearToast.hidden = true; }, 300);
          }, 6000);

          if (clearUndoBtn) {
            var undoHandler = function () {
              window.clearTimeout(hideTimer);
              api.setAll(snapshotItems);
              setShareName(snapshotName);
              refreshWishlistWording();
              renderDrawerList();
              refreshDrawerHeaderMeta(snapshotItems.length);
              clearToast.classList.remove('is-visible');
              window.setTimeout(function () { clearToast.hidden = true; }, 300);
              clearUndoBtn.removeEventListener('click', undoHandler);
            };
            clearUndoBtn.addEventListener('click', undoHandler);
          }
        }
      });
    }

    if (drawer) {
      var outsideStart = null;
      document.addEventListener('pointerdown', function (e) {
        outsideStart = { x: e.clientX, y: e.clientY };
      });
      document.addEventListener('click', function (e) {
        if (!drawer.classList.contains('is-open')) return;
        var panel = drawer.querySelector('.gw-drawer__panel');
        // Use composedPath() (the propagation path captured at dispatch
        // time), not panel.contains(e.target) — a remove-item click
        // detaches its own element from the DOM inside its handler
        // (itemEl.remove()), so by the time this listener runs,
        // e.target is already disconnected and panel.contains(e.target)
        // wrongly reports false, treating an inside click as "outside"
        // and closing the drawer right after every removal.
        var path = typeof e.composedPath === 'function' ? e.composedPath() : [e.target];
        if (path.indexOf(panel) !== -1) return;
        if (e.target.closest && e.target.closest('#gw-wishlist-icon')) return;
        if (e.target.closest && e.target.closest('[data-gwtd-wishlist-link]')) return;
        if (e.target.closest && e.target.closest('#gw-wishlist-toast-view')) return;
        // "View all ♥" in the tarot deck's picks strip also opens the
        // drawer directly (not via the header icon) — without this
        // exclusion, the very click that opens it bubbles up to this
        // same listener and, since it's outside the drawer panel, gets
        // treated as an outside click and closes the drawer again in
        // the same tick (A2, found by reproducing live: openDrawer()
        // was confirmed to run and add is-open, which then disappeared
        // immediately after).
        if (e.target.closest && e.target.closest('[data-gwtd-picks-viewall]')) return;
        // Slim sticky header's own wishlist icon calls openDrawer()
        // directly too (unlike its cart/search buttons, which delegate
        // via a synthetic .click() on the main header's controls) — same
        // same-tick-reopen-then-close bug as above.
        if (e.target.closest && e.target.closest('[data-gw-slim-wishlist]')) return;
        if (outsideStart) {
          var dx = Math.abs((e.clientX || 0) - outsideStart.x);
          var dy = Math.abs((e.clientY || 0) - outsideStart.y);
          if (dx > 8 || dy > 8) return;
        }
        closeDrawer();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
      });
    }
  }

  function REDUCED_MOTION() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function bounceMainHeaderIcon() {
    var el = document.getElementById('gw-wishlist-icon');
    if (!el) return;
    el.classList.remove('is-bouncing');
    void el.offsetWidth;
    el.classList.add('is-bouncing');
  }

  /* Flies a small heart from wherever a card was saved to whichever
     header wishlist icon is currently on screen — the full header's
     #gw-wishlist-icon, or the slim sticky header's own icon
     (window.gwSlimHeader, from gw-slim-header.js) if that's the one
     visible right now. On phones, if the slim bar is hidden at the
     moment of saving, this asks it to slide in first so the heart has
     somewhere real to land, matching it against the icon's position
     only after that slide-in transition has actually settled.
     startRect: a DOMRect (or plain {left,top,width,height}) for
     wherever the heart should start flying from — the saved card. */
  function flyHeartFrom(startRect) {
    if (!startRect) return;
    if (REDUCED_MOTION()) return; // just the count update, no flight

    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var slim = window.gwSlimHeader;
    var usingSlim = false;
    var justRevealedSlim = false;
    var targetEl = null;

    if (slim) {
      if (isMobile) {
        usingSlim = true;
        if (!slim.isVisible()) {
          justRevealedSlim = true;
          slim.showTemporarily(2500);
        }
      } else if (slim.isVisible()) {
        usingSlim = true;
      }
    }
    if (usingSlim) targetEl = slim.getWishlistIconEl();
    if (!targetEl) targetEl = document.getElementById('gw-wishlist-icon');
    if (!targetEl) return;

    function launch() {
      var endRect = targetEl.getBoundingClientRect();
      if (endRect.width === 0 && endRect.height === 0) return; // icon not actually visible/laid out

      var heart = document.createElement('div');
      heart.className = 'gw-flying-heart';
      heart.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
      var startCx = startRect.left + startRect.width / 2 - 11;
      var startCy = startRect.top + startRect.height / 2 - 11;
      heart.style.left = startCx + 'px';
      heart.style.top = startCy + 'px';
      document.body.appendChild(heart);
      void heart.offsetWidth; // commit the start position before animating, same reflow trick used elsewhere

      var endCx = endRect.left + endRect.width / 2 - 11;
      var endCy = endRect.top + endRect.height / 2 - 11;
      heart.style.transform = 'translate(' + (endCx - startCx) + 'px, ' + (endCy - startCy) + 'px) scale(0.35)';
      heart.style.opacity = '0';

      var done = false;
      function finish() {
        if (done) return;
        done = true;
        heart.remove();
        if (usingSlim) slim.bounceWishlistIcon();
        else bounceMainHeaderIcon();
      }
      heart.addEventListener('transitionend', finish, { once: true });
      window.setTimeout(finish, 800);
    }

    // If the slim bar was just told to slide in, wait for that CSS
    // transition to finish before measuring its icon's real position.
    if (justRevealedSlim) {
      window.setTimeout(launch, 280);
    } else {
      launch();
    }
  }

  // First-visit-only tip, shown once next to the first visible heart on
  // the page (C3). Positioned with getBoundingClientRect() against a
  // fixed-position tip element rather than inserted per-card, since it
  // only ever needs to point at ONE heart at a time. Disappears as soon
  // as any heart anywhere is tapped, or the tip itself is dismissed, and
  // never shows again after that (localStorage, try/catch — if storage
  // is blocked this just falls back to showing every visit rather than
  // breaking anything).
  function tipSeen() {
    try { return localStorage.getItem(TIP_SEEN_KEY) === '1'; } catch (e) { return true; }
  }
  function markTipSeen() {
    try { localStorage.setItem(TIP_SEEN_KEY, '1'); } catch (e) {}
    hideTip();
  }
  function hideTip() {
    var tip = document.getElementById('gw-wishlist-tip');
    if (tip) tip.hidden = true;
  }
  function maybeShowTip(heartEl) {
    if (tipSeen() || !heartEl) return;
    var tip = document.getElementById('gw-wishlist-tip');
    if (!tip) return;
    if (!tip.hidden && tip.dataset.shown === '1') return; // already pointed at a heart this load
    var textEl = document.getElementById('gw-wishlist-tip-text');
    if (textEl) textEl.textContent = labels().tipText;
    var closeBtn = document.getElementById('gw-wishlist-tip-close');
    if (closeBtn && !closeBtn.dataset.wired) {
      closeBtn.dataset.wired = '1';
      closeBtn.addEventListener('click', markTipSeen);
    }
    var rect = heartEl.getBoundingClientRect();
    tip.style.top = (window.scrollY + rect.bottom + 8) + 'px';
    tip.style.left = Math.max(8, window.scrollX + rect.left + rect.width / 2 - tip.offsetWidth / 2) + 'px';
    tip.hidden = false;
    tip.dataset.shown = '1';
    // Re-measure once it has a real box (offsetWidth is 0 while hidden).
    window.requestAnimationFrame(function () {
      tip.style.left = Math.max(8, window.scrollX + rect.left + rect.width / 2 - tip.offsetWidth / 2) + 'px';
    });
  }

  api.openDrawer = openDrawer;
  api.closeDrawer = closeDrawer;
  api.flyHeartFrom = flyHeartFrom;
  api.markTipSeen = markTipSeen;
  api.maybeShowTip = maybeShowTip;
  api.hideTip = hideTip;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawer);
  } else {
    initDrawer();
  }
})();
